import React from "react";
import moment from "moment";
import EventListener from "react-event-listener";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";
import EventStore from "../stores/EventStore";
import EventActions from "../actions/EventActions";
import VenueStore from "../stores/VenueStore";
import VenueActions from "../actions/VenueActions";
import TagStore from "../stores/TagStore";
import TagActions from "../actions/TagActions";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import StatsBlockContainer from "./partials/stats-block-container.jsx";
import StatsBlock from "./partials/stats-block.jsx";

import AttendeeAnalyticsTable from "./partials/attendee-analytics-table.jsx";
import FromCacheCallout from "./partials/from-cache-callout.jsx";

import AnalyticsFilterWidget from "./partials/analytics-filter-widget.jsx";

import { formatNumber } from "../util";

class AttendeeAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRangeEditor: false,
      allTime: false,
      range: {
        key: "selection",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filterState: "all"
    };

    this.onWindowClick = this.onWindowClick.bind(this);
    this.onWindowKeyDown = this.onWindowKeyDown.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSegmentFilterChange = this.handleSegmentFilterChange.bind(this);
  }

  static getStores() {
    return [EventBucketStore, EventStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    const eventState = EventStore.getState();
    const venueState = VenueStore.getState();
    const tagState = TagStore.getState();

    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      events: eventState.events,
      venues: venueState.venues,
      tags: tagState.tags,
      isFetching:
        eventState.isFetching || venueState.isFetching || tagState.isFetching,
      getIsFetchingAttendeeAnalytics: AnalyticsStore.getIsFetchingAttendeeAnalytics,
      getEventsForEventBucket: EventStore.getEventsForEventBucket,
      getAttendeeAnalytics: AnalyticsStore.getAttendeeAnalytics
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  onWindowClick(e) {
    if (
      this.state.showRangeEditor &&
      (!this.container ||
        (!this.container.contains(e.target) &&
          !this.rangeButton.contains(e.target)))
    ) {
      this.setState({ showRangeEditor: false });
    }
  }

  onWindowKeyDown(e) {
    if (this.state.showRangeEditor && e.which === 27) {
      // esc
      this.setState({ showRangeEditor: false });
    }
  }

  handleSegmentFilterChange(props) {
    this.setState({ filterState: props },
      () => this.componentWillReceiveProps(this.props, true)
    )
  }

  handleDateChange({ range, allTime }) {
    this.setState({ range: range, allTime: allTime },
      () => this.componentWillReceiveProps(this.props, true)
    );
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillMount() {
    EventBucketActions.fetchOne.defer(this.props.params.eventBucketId);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      force === true ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      AnalyticsActions.fetchAttendeeAnalytics.defer({
        eventBucketId: newProps.params.eventBucketId,
        filterState: this.state.filterState,
        startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
        endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
        allTime: this.state.allTime
      });
      EventActions.fetchAllForBucket.defer(newProps.params.eventBucketId);
      VenueActions.fetchAllForBucket.defer(newProps.params.eventBucketId);
      TagActions.fetchAllForBucket.defer(newProps.params.eventBucketId);
      EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
    }
  }

  render() {
    const { eventBucketId } = this.props.params;
    if (!eventBucketId) {
      return <div><WorkingIndicator fullPage={true} /></div>
    }
    const { events, tags, venues, isFetching } = this.props;
    const eventBucket = this.props.getEventBucketById(eventBucketId);
    if (!eventBucket) {
      return <div><WorkingIndicator fullPage={true} /></div>
    }
    const eventBucketEvents = this.props.getEventsForEventBucket(eventBucketId);
    const attendeeAnalytics = this.props.getAttendeeAnalytics(eventBucketId);
    const defaultItemsPerPage = 25;

    return (
      <div className="attendee-analytics">
        <EventListener
          target="window"
          onClick={this.onWindowClick}
          onKeyDown={this.onWindowKeyDown}
        />
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label="attendee analytics"
          subpath="attendees"
          query={this.props.location.query}
          hideHeader={true}
        />
        <h1 style={{ lineHeight: 1.2 }}>
          "{eventBucket.name}" attendee analytics
        </h1>
        <AnalyticsFilterWidget
          showDateFilter={true}
          onDateRangeChange={this.handleDateChange}
          showSegmentFilter={true}
          onSegmentFilterChange={this.handleSegmentFilterChange}
          segmentFilterTitle={"Filter by event type"}
          segmentFilterSelected={this.state.filterState}
          segmentFilterConfig={[
            {
              value: "all",
              label: "All Events"
            },
            {
              value: "physical",
              label: "Physical Events"
            },
            {
              value: "virtual",
              label: "Virtual Events"
            },
            {
              value: "undatedEvents",
              label: "Undated Events"
            },
          ]}
        />
        <FromCacheCallout analytics={attendeeAnalytics} />
        {
          !attendeeAnalytics
            || !eventBucket
            || (eventBucketEvents.length === 0 && isFetching)
            || this.props.isFetching
            || this.props.getIsFetchingAttendeeAnalytics()
            ? (
              <div><WorkingIndicator fullPage={true} /></div>
            ) : (
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex"
                  }}>
                  <p>
                    Scroll down to view attendance <a href="#by-event">by event</a>,{" "}
                    <a href="#by-venue">by venue</a>, <a href="#by-tag">by tag</a>, and{" "}
                    <a href="#by-date">by date</a>.
                  </p>
                </div>
                <StatsBlockContainer style={{ marginTop: -10 }}>
                  <StatsBlock
                    value={formatNumber(attendeeAnalytics.unique_count)}
                    label={
                      <span>
                        Unique attendees{" "}
                        <a
                          href="https://help.eventive.org/analyzing-your-data/what-are-unique-attendees"
                          target="_blank"
                          style={{ textDecoration: "none" }}
                        >
                          (?)
                        </a>
                      </span>
                    }
                  />
                  <StatsBlock
                    value={formatNumber(attendeeAnalytics.unique_used_count)}
                    /*subvalue={`${(attendeeAnalytics.unique_used_count / attendeeAnalytics.unique_count * 100).toFixed(2)}%)`}*/
                    label={"Unique scanned attendees"}
                  />
                  <StatsBlock
                    value={formatNumber(attendeeAnalytics.total_count)}
                    label={"Tickets issued"}
                  />
                  <StatsBlock
                    value={formatNumber(attendeeAnalytics.total_used_count)}
                    /*subvalue={`${(attendeeAnalytics.total_used_count / attendeeAnalytics.total_count * 100).toFixed(2)}%`}*/
                    label={"Tickets scanned"}
                  />
                </StatsBlockContainer>
                <a className="anchor--fixed_header_offset" id="by-event" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                    Attendance by event(scanned / total)
                  </h2>
                  <AttendeeAnalyticsTable
                    eventBucket={eventBucket}
                    events={events}
                    data={attendeeAnalytics.by_event}
                    itemsPerPage={defaultItemsPerPage}
                    groupBy="event"
                    tableFilter={true}
                  />
                </div>
                <a className="anchor--fixed_header_offset" id="by-venue" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                    Attendance by venue (scanned / total)
                  </h2>
                  <AttendeeAnalyticsTable
                    eventBucket={eventBucket}
                    venues={venues}
                    events={events}
                    itemsPerPage={defaultItemsPerPage}
                    groupBy="venue"
                    data={attendeeAnalytics.by_event}
                  />
                </div>
                <a className="anchor--fixed_header_offset" id="by-tag" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                    Attendance by tag (scanned / total)
                  </h2>
                  <AttendeeAnalyticsTable
                    eventBucket={eventBucket}
                    tags={tags}
                    events={events}
                    itemsPerPage={defaultItemsPerPage}
                    groupBy="tag"
                    data={attendeeAnalytics.by_event}
                  />
                </div>
                <a className="anchor--fixed_header_offset" id="by-date" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                    Attendance by date (scanned / total)
                  </h2>
                  <AttendeeAnalyticsTable
                    eventBucket={eventBucket}
                    tags={tags}
                    events={events}
                    itemsPerPage={defaultItemsPerPage}
                    groupBy="date"
                    data={attendeeAnalytics.by_event}
                  />
                </div>
              </div>
            )}
      </div>
    );
  }
}

export default connectToStores(AttendeeAnalytics);


// WEBPACK FOOTER //
// ./src/app/components/attendee-analytics.jsx